const ITEMS = [
  "CAD-Designed",
  "Custom-Fit",
  "No Universal Kits",
  "3D-Printed In-House",
  "Track Ready",
  "Brisbane · Australia",
  "Nissan 350Z (Z33)",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative bg-[#e31e24] py-4 overflow-hidden border-y border-black/20"
      data-testid="marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-3xl text-white px-6 tracking-wide">
              {t}
            </span>
            <span className="h-2.5 w-2.5 bg-white rotate-45 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
